// extracted by mini-css-extract-plugin
module.exports = {"btnGreen":"styles_btnGreen__1VJmR","btnRed":"styles_btnRed__2b7H5","container":"styles_container__3xfVc","content":"styles_content__k3jh7"};